.root {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
}

.topRow {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    flex-direction: row;
}

.main {
    display: flex;
    flex: 1;
    min-width: 0;
    gap: 8px;
    row-gap: 8px;
    flex-wrap: nowrap;
}

.title {
    line-height: 1.1;
    font-weight: 600;
    flex-shrink: 0;
}

.searchWrap {
    width: 700px;
    flex-shrink: 1;
    min-width: 0;
}

.searchWrap :global(.MuiTextField-root) {
    width: 100%;
    max-width: 100%;
    background-color: var(--mui-palette-common-white, #fff);
}

.controls,
.filter,
.sort {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
    flex-wrap: nowrap;
}

.actions :global(.MuiButton-root) {
    white-space: nowrap;
}

.actions :global(.MuiButton-outlined) {
    background-color: var(--mui-palette-common-white, #fff);
}

.status {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.status :global(.MuiChip-root) {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.status :global(.MuiSvgIcon-root) {
    margin-left: 8px;
    font-size: 20px;
}

@media (max-width: 1500px) {
    .searchWrap {
        width: 400px;
    }
}

@media (max-width: 900px) {
    .root {
        gap: 8px;
    }

    .topRow {
        align-items: center;
        gap: 8px;
    }

    .main {
        align-items: stretch;
    }

    .searchWrap {
        flex: 1;
        width: auto;
    }

    .controls {
        min-width: fit-content;
    }

    .filter,
    .sort {
        display: none;
    }

    .actions {
        flex-wrap: wrap;
    }
}
